import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Round 74 item 8: the owner's dashboard task while a quarterly access review is open. Id prefixes only.
export const AccessReviewBanner = ({ token, onOpen }) => {
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/admin/access-reviews`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setOpen(r.data.open || null)).catch(() => setOpen(null));
  }, [token]);
  if (!open) return null;
  const decided = Object.keys(open.decisions || {}).length;
  return (
    <div className="bg-sky-600 text-sky-50" data-testid="access-review-banner" role="status">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex flex-wrap items-center gap-3 text-sm">
        <span className="font-semibold">Task: quarterly access review {open.period} is open — {decided}/{open.admins.length} account(s) decided, due {open.due_at?.slice(0, 10)}</span>
        <Button size="sm" variant="secondary" className="rounded-full ml-auto" onClick={onOpen} data-testid="access-review-open-diagnostics">Open review</Button>
      </div>
    </div>
  );
};
